var React = require('react');

function IconCross (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"#icon-cross path{fill:transparent}"),React.createElement("g",{"className":"icon-line--style icon-line--miter-limit icon-line--linecap","key":1},React.createElement("path",{"d":"M111.5 55.7c0 30.8-25 55.7-55.7 55.7S0 86.5 0 55.7 25 0 55.7 0s55.8 25 55.8 55.7zM80.1 28.7L28.7 80.1M28.7 28.7l51.4 51.4","transform":"translate(8 8)"}))]);
}

IconCross.defaultProps = {"height":"44","version":"1.1","viewBox":"0 0 128 128","id":"icon-cross","className":"icon-cross svg--fill-none"};

module.exports = IconCross;

IconCross.default = IconCross;
